export const iconFontAwesomeSecurityPersonDressBurst = (
	<i className="fa-solid fa-person-dress-burst"></i>
);
